<template>
  <div v-if="dynamicParam || dynamicParamCounty || dynamicParamJur || dynamicParamTomwship" >
    <div :class="breadCrumbCls">
      <span v-if="dynamicParamCounty || dynamicParamJur || dynamicParamTomwship">
        <router-link class="hideUnderline fontcolorNew"
        :to="{ name: 'StateCodeAdoption',
        params: { stateName: dynamicParam.replace(/\s+/g, '-') } }">
        {{ dynamicParam }}
        </router-link>
      </span>
      <span v-if="dynamicParam && dynamicParamCounty && dynamicParamTomwship">
        >
        <router-link class="hideUnderline fontcolorNew"
        :to="{ name: 'CountyCodeAdoption',
        params: { stateName: dynamicParam.replace(/\s+/g, '-'), countyName: dynamicParamCounty.replace(/\s+/g, '-') } }">
        {{ dynamicParamCounty }}
        </router-link>
      </span>
    </div>
  </div>
  <div v-else style="height:0px !important"  ></div>
</template>
<script>
export default {
  name: 'Breadcrumb',
  data: () => ({
    dynamicParam: '',
    dynamicParamCounty: '',
    dynamicParamJur: '',
    dynamicParamTomwship: '',
    countryDetails: {}
  }),
  props: {
    callOnProfilePage: Boolean
  },
  mounted () {
    this.prepareSearchCall()
    this.$globalFromValidation.forceTabActive(this.$route.name)
  },
  computed: {
    shouldBookMarkApiCall () {
      return this.$store.getters['FESearchModule/fetchCheckBookMarkSearchAPI']
    },
    breadCrumbCls () {
      return this.callOnProfilePage ? 'text-uppercase sm-breadcrum-txt pl-1 pr-1 pr-sm-2 pl-sm-2' : 'text-uppercase breadcrum-txt pr-1 pr-sm-2'
    }
  },
  methods: {
    generateProfileSectionData (metadata) {
      if (metadata.adoptionLevel === '1') {
        return {
          entitySeal: metadata.stateLogo,
          entityName: metadata.stateName,
          entityAbbreviation: metadata.countryAbbr,
          jurisdictionUrl: metadata.stateUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.stateProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: metadata.stateAbbr,
          adoptionDescription: metadata.adoptionDescription,
          usefulLinks: metadata.usefulLinks
        }
      } else if (metadata.adoptionLevel === '2') {
        return {
          entitySeal: metadata.countyLogo,
          entityName: metadata.countyName,
          entityAbbreviation: metadata.stateAbbr,
          jurisdictionUrl: metadata.countyUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.countyProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: '',
          adoptionDescription: metadata.adoptionDescription,
          usefulLinks: metadata.usefulLinks
        }
      } else if (metadata.adoptionLevel === '3') {
        return {
          entitySeal: metadata.jurisdictionLogo,
          entityName: metadata.jurisdictionName,
          entityAbbreviation: metadata.stateAbbr,
          jurisdictionUrl: metadata.jurisdictionUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.jurisdictionProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: '',
          adoptionDescription: metadata.adoptionDescription,
          usefulLinks: metadata.usefulLinks
        }
      } else if (metadata.adoptionLevel === '4') {
        return {
          entitySeal: metadata.townshipLogo,
          entityName: metadata.townshipName,
          entityAbbreviation: metadata.stateAbbr,
          jurisdictionUrl: metadata.townshipUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.townshipProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          countyName: metadata.countyName,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: '',
          adoptionDescription: metadata.adoptionDescription,
          usefulLinks: metadata.usefulLinks
        }
      } else if (metadata.adoptionLevel === '') {
        return {
          entitySeal: metadata.townshipLogo,
          entityName: metadata.townshipName,
          countryName: this.countryDetails.name,
          entityAbbreviation: this.countryDetails.abbreviation,
          jurisdictionUrl: metadata.townshipUrl,
          amendmentUrl: metadata.amendmentUrl,
          jurisdictionProfile: metadata.townshipProfile,
          timeStamp: metadata.timestamp,
          adoptionLevel: metadata.adoptionLevel,
          stateName: metadata.stateName,
          countryAbbr: metadata.countryAbbr,
          countyName: this.countryDetails.name,
          metaCountyList: metadata.metaCountyList,
          metaPostalList: metadata.metaPostalList,
          stateAbbr: '',
          adoptionDescription: this.countryDetails.adoption,
          usefulLinks: metadata.usefulLinks
        }
      }
    },
    countryAdoptionDetail (metadata) {
      if (metadata.adoptionLevel === '') {
        let countryName = typeof this.$route.params.countryName !== 'undefined' ? this.$route.params.countryName.replace(/-/g, ' ') : this.$route.params.countryName
        const formData = {
          countryName: countryName
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('AuthModule/fetchFeToken', { resolve, reject })
        }).then((tokenData) => {
          let tokens = tokenData.data
          this.$store.dispatch('AuthModule/setJWTTokens', { tokens }).then(() => {
            new Promise((resolve, reject) => {
              this.$store.dispatch('CountryDetailModule/countryDetails', {
                resolve,
                reject,
                formData
              })
            })
              .then(responseData => {
                this.countryDetails = responseData
                let responseObject = this.generateProfileSectionData(responseData.metaList)
                this.$store.commit('FEMapModule/setMetaData', responseObject)
                this.$emit('dataLoader', false)
              })
              .catch(({ response }) => {
                let responseObject = this.generateProfileSectionData(metadata)
                this.$store.commit('FEMapModule/setMetaData', responseObject)
                this.$emit('dataLoader', false)
              })
          }).catch()
        }).catch()
      }
    },
    prepareSearchCall () {
      this.dynamicParam = typeof this.$route.params.stateName !== 'undefined' ? this.$route.params.stateName.replace(/-/g, ' ') : this.$route.params.stateName
      this.dynamicParamCounty = typeof this.$route.params.countyName !== 'undefined' ? this.$route.params.countyName.replace(/-/g, ' ') : this.$route.params.countyName
      this.dynamicParamJur = typeof this.$route.params.jurisdictionName !== 'undefined' ? this.$route.params.jurisdictionName.replace(/-/g, ' ') : this.$route.params.jurisdictionName
      this.dynamicParamTomwship = typeof this.$route.params.townshipName !== 'undefined' ? this.$route.params.townshipName.replace(/-/g, ' ') : this.$route.params.townshipName
      const formData = {
        stateName: this.dynamicParam,
        countyName: this.dynamicParamCounty,
        jurisdictionName: this.dynamicParamJur,
        townshipName: this.dynamicParamTomwship
      }
      if (!this.shouldBookMarkApiCall) {
        this.$emit('dataLoader', true)
        this.$emit('defaultAdoptionItems', 'Current')
        new Promise((resolve, reject) => {
          this.$store.dispatch('AuthModule/fetchFeToken', { resolve, reject })
        }).then((tokenData) => {
          let tokens = tokenData.data
          this.$store.dispatch('AuthModule/setJWTTokens', { tokens }).then(() => {
            new Promise((resolve, reject) => {
              this.$store.dispatch('FESearchModule/fetchBooksOnLoad', {
                resolve,
                reject,
                formData
              })
            })
              .then(responseData => {
                if (responseData.metaList.adoptionLevel === '') {
                  this.countryAdoptionDetail(responseData.metaList)
                } else {
                  let responseObject = this.generateProfileSectionData(responseData.metaList)
                  this.$store.commit('FEMapModule/setMetaData', responseObject)
                  this.$emit('dataLoader', false)
                  this.$store.commit('FESearchModule/setCheckBookMarkSearchAPI')
                }
              })
              .catch(response => {
                if (response.metaList.adoptionLevel === '') {
                  this.countryAdoptionDetail(response.metaList)
                } else {
                  let responseObject = this.generateProfileSectionData(response.metaList)
                  this.$store.commit('FEMapModule/setMetaData', responseObject)
                  this.$emit('dataLoader', false)
                }
              })
          }).catch()
        }).catch()
      }
    }
  }
}
</script>
